import FACET_CODES from './facetCodes';
import PRODUCT_CODES from './productCodes';
import SHOP_PARAMETER_CODES from './shopParameterCodes';
import EMAIL_CODES from './emailCodes';

const ActionTypes = {
  REQUEST: {
    [FACET_CODES.MANUFACTURER]: 'REQUEST_MANUFACTURERS',
    [FACET_CODES.CHUCK_TYPE]: 'REQUEST_CHUCK_TYPES',
    [FACET_CODES.CHUCK_SIZE]: 'REQUEST_CHUCK_SIZES',
    [FACET_CODES.CHUCK_DETAIL]: 'REQUEST_CHUCK_DETAILS',
    [PRODUCT_CODES.PRODUCTS]: 'REQUEST_PRODUCTS',
    [EMAIL_CODES.PRICING_REQUEST]: 'REQUEST_EMAIL_PRICING'
  },
  UPDATE: {
    [FACET_CODES.MANUFACTURER]: 'UPDATE_MANUFACTURERS',
    [FACET_CODES.CHUCK_TYPE]: 'UPDATE_CHUCK_TYPES',
    [FACET_CODES.CHUCK_SIZE]: 'UPDATE_CHUCK_SIZES',
    [FACET_CODES.CHUCK_DETAIL]: 'UPDATE_CHUCK_DETAILS',
    [PRODUCT_CODES.PRODUCTS]: 'UPDATE_PRODUCTS',
    [SHOP_PARAMETER_CODES.PARAMETERS]: 'UPDATE_SHOP_PARAMETERS',
    [EMAIL_CODES.PRICING_REQUEST]: 'UPDATE_EMAIL_PRICING'
  },
  SELECT: {
    [FACET_CODES.MANUFACTURER]: 'SELECT_MANUFACTURER',
    [FACET_CODES.CHUCK_TYPE]: 'SELECT_CHUCK_TYPE',
    [FACET_CODES.CHUCK_SIZE]: 'SELECT_CHUCK_SIZE',
    [FACET_CODES.CHUCK_DETAIL]: 'SELECT_CHUCK_DETAIL',
    [PRODUCT_CODES.PRODUCTS]: 'SELECT_PRODUCTS'
  },
  FAILED2FETCH: {
    [FACET_CODES.MANUFACTURER]: 'MANUFACTURERS_FETCH_FAILED',
    [FACET_CODES.CHUCK_TYPE]: 'FETCH_CHUCK_TYPES_FAILED',
    [FACET_CODES.CHUCK_SIZE]: 'FETCH_CHUCK_SIZES_FAILED',
    [FACET_CODES.CHUCK_DETAIL]: 'FETCH_CHUCK_DETAILS_FAILED',
    [PRODUCT_CODES.PRODUCTS]: 'FETCH_PRODUCTS_FAILED',
    [SHOP_PARAMETER_CODES.PARAMETERS]: 'UPDATE_SHOP_PARAMETERS_FAILED',
    [EMAIL_CODES.PRICING_REQUEST]: 'REQUEST_EMAIL_PRICING_FAILED'
  }
};

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js